import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import {
  MagnifyingGlass,
  Buildings,
  ChatText,
} from '@phosphor-icons/react';

function MobileSupplierMenu() {
  const navigate = useNavigate();
  
  const supplierOptions = [
    {
      title: 'Find Suppliers',
      description: 'Search for wedding vendors',
      icon: <MagnifyingGlass size={32} weight="regular" />,
      path: '/supplier-search',
    },
    {
      title: 'Your Suppliers',
      description: 'Your suppliers and shortlist',
      icon: <Buildings size={32} weight="regular" />,
      path: '/suppliers',
    },
    {
      title: 'Messages',
      description: 'Chat with your vendors',
      icon: <ChatText size={32} weight="regular" />,
      path: '/dashboard/supplier-chat',
    },
  ];

  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Supplier Management
      </Typography>
      
      <Grid container spacing={2}>
        {supplierOptions.map((option) => (
          <Grid item xs={6} key={option.title}>
            <Paper
              elevation={1}
              sx={{
                p: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: 2,
                transition: 'all 0.2s',
                '&:hover': {
                  bgcolor: 'action.hover',
                  transform: 'translateY(-2px)',
                  boxShadow: 2,
                },
              }}
              onClick={() => navigate(option.path)}
            >
              <Box sx={{ mb: 1, color: 'primary.main' }}>
                {option.icon}
              </Box>
              <Typography variant="subtitle1" fontWeight="medium">
                {option.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {option.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default MobileSupplierMenu; 